import React from 'react';
import { ErrorMessage } from 'formik';
import { Typography, Checkbox, Radio, Space } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { colors, priorConditionOptions } from '../constants';
import {
  StepTitle, FormSection, FormItem, SectionTitle, ErrorText,
  InfoBox, LargeCheckbox, LargeRadio
} from '../styledComponents';

const { Paragraph } = Typography;

const StepHealthHistory = ({ values, setFieldValue }) => (
  <>
    <StepTitle level={4}>Health History</StepTitle>
    <InfoBox>
      <div className="icon"><InfoCircleOutlined /></div>
      <div className="content">
        <Paragraph style={{ margin: 0, color: colors.text }}>
          Your health history helps us interpret your test results more accurately. Lp(a) levels are largely
          genetic but can be affected by other health conditions.
        </Paragraph>
      </div>
    </InfoBox>
    
    <FormSection>
      <FormItem>
        <SectionTitle>Have you ever been diagnosed with any of the following?</SectionTitle>
        <Paragraph style={{ fontSize: '14px', color: colors.text, marginTop: '6px', marginBottom: '14px', lineHeight: '1.5', fontWeight: '400' }}>
          Select all that apply:
        </Paragraph>
        <div style={{ marginTop: '16px' }}>
          <Checkbox.Group
            style={{ width: '100%' }}
            value={values.priorConditions}
            onChange={(checkedValues) => setFieldValue('priorConditions', checkedValues)}
          >
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              {priorConditionOptions.map(option => (
                <LargeCheckbox key={option.value} value={option.value}>
                  {option.label}
                </LargeCheckbox>
              ))}
            </Space>
          </Checkbox.Group>
        </div>
      </FormItem>
    </FormSection>
    
    <FormSection>
      <FormItem>
        <SectionTitle>Have you ever seen or been referred to a cardiologist?</SectionTitle>
        <div style={{ marginTop: '14px' }}>
          <Radio.Group
            value={values.referredToCardiologist}
            onChange={(e) => setFieldValue('referredToCardiologist', e.target.value)}
          >
            <Space direction="horizontal" size="large" wrap>
              <LargeRadio value="yes">Yes</LargeRadio>
              <LargeRadio value="no">No</LargeRadio>
            </Space>
          </Radio.Group>
        </div>
        <ErrorMessage name="referredToCardiologist" component={ErrorText} />
      </FormItem>
    </FormSection>
  </>
);

export default StepHealthHistory;
